import events from '@wizer/core/events'

export default {
  methods: {
    itemClicked() {
      if (this.item.onClick) {
        document.getElementById('e360Frame').contentWindow.postMessage(
          {
            command: 'menu-item-clicked',
            jsAction: this.item.onClick,
          },
          '*',
        )
      }
      events.publish('clicked', {
        withAction: !!this.item.onClick,
      })
    },

    itemOver(event) {
      events.publish('over', {
        id: this.item.id,
        path: this.item.path,
        target: event.target,
        ref: this.$refs.menuChildrenItem,
      })
    },

    itemOut() {
      events.publish('out', {
        id: this.item.id,
      })
    },
  },
}
